"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentWrapper = _interopRequireDefault(require("../helpers/ComponentWrapper"));
var _currency = require("../../currency");
var _CardSlider = _interopRequireDefault(require("../CardSlider/CardSlider"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Card = _interopRequireDefault(require("../Card/Card"));
var _constants = require("../constants");
var _MediaContext = require("../MediaContext/MediaContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DestinationCardsSlider = function DestinationCardsSlider(_ref) {
  var destinations = _ref.destinations,
    title = _ref.title,
    small = _ref.small,
    hideTitle = _ref.hideTitle;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    lessThan: _constants.BREAKPOINTS.MD
  }, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, !hideTitle && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-ls-sm text-center"
  }, title || 'Destinations'), destinations ? /*#__PURE__*/_react["default"].createElement(_CardSlider["default"], {
    snap: true
  }, destinations.map(function (destination) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "".concat(JSON.stringify(destination)),
      className: "padding-sm height-100% padding-bottom-lg"
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: "/".concat(destination.slug)
    }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      template: "ImageCard",
      imageCardTemplate: "DestinationWide",
      size: "xl",
      className: "d8-u-hover-shadow-xl overflow-hidden destination-card-wide",
      bgImage: {
        url: destination.featured_image_src,
        alt: destination.seo_title
      },
      noComponentPadding: true,
      price: destination.minPrice || null,
      textMain: destination.title.rendered,
      whiteFont: true,
      dates: destination.acf.info.months || null,
      overlay: true,
      soldOut: destination.destinationStatus !== 'coming_soon' && !destination.minPrice
    })));
  })) : /*#__PURE__*/_react["default"].createElement("p", null, "No destinations found."))), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    greaterThanOrEqual: _constants.BREAKPOINTS.MD
  }, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, small ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hideTitle && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-ls-sm text-center margin-bottom-sm"
  }, title || 'Destinations'), destinations ? /*#__PURE__*/_react["default"].createElement(_CardSlider["default"], null, destinations.map(function (destination) {
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      key: "".concat(JSON.stringify(destination)),
      href: "/".concat(destination.slug)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "padding-y-sm padding-x-sm"
    }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      template: "ImageCard",
      imageCardTemplate: "Basic",
      className: "d8-u-hover-shadow-xl overflow-hidden",
      bgImage: {
        url: destination.featured_image_src,
        alt: destination.seo_title
      },
      noComponentPadding: true,
      whiteFont: true,
      overlay: true,
      noPadding: true,
      size: "xs"
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-text-bold text-md margin-top-sm d8-u-color-black"
    }, destination.title.rendered), !!destination.minPrice && parseFloat(destination.minPrice) > 1 ? /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-color-contrast-high"
    }, "From ", /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
      amount: destination.minPrice || null,
      baseCurrency: "EUR"
    }), "/ person") : ''));
  })) : /*#__PURE__*/_react["default"].createElement("p", null, "No destinations found.")) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hideTitle && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-ls-sm text-center"
  }, title || 'Destinations'), destinations ? /*#__PURE__*/_react["default"].createElement(_CardSlider["default"], null, destinations.map(function (destination, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "".concat(JSON.stringify(destination)),
      className: "padding-sm height-100% padding-bottom-xl"
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: "/".concat(destination.slug)
    }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      template: "ImageCard",
      imageCardTemplate: "DestinationWide",
      className: "d8-u-hover-shadow-xl overflow-hidden destination-card-wide",
      size: "xl",
      bgImage: {
        url: destination.featured_image_src,
        alt: destination.seo_title
      },
      noComponentPadding: true,
      price: destination.minPrice || null,
      textMain: destination.title.rendered,
      whiteFont: true,
      dates: destination.acf.info.months || null,
      overlay: true,
      video: destination.acf.hero.mobile_video || null,
      soldOut: destination.destinationStatus !== 'coming_soon' && !destination.minPrice // removing this for bookings opening
    })));
  })) : /*#__PURE__*/_react["default"].createElement("p", null, "No destinations found.")))));
};
DestinationCardsSlider.propTypes = {
  destinations: _propTypes["default"].array.isRequired,
  title: _propTypes["default"].string,
  small: _propTypes["default"].bool
};
var _default = exports["default"] = DestinationCardsSlider;